// Account roles and the space each one lands in

export const isOperator = (role) =>
  role === "operator" || role === "head_operator";

const SPACES = {
  user: "/user",
  admin: "/admin",
  sales: "/sales",
};

export const spacePathFor = (role) =>
  SPACES[role] || (isOperator(role) ? "/operator" : "/");
